/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'scheduled-note-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M19.5 2H18V.5a.5.5 0 0 0-1 0V2h-4V.5a.5.5 0 0 0-1 0V2H8V.5a.5.5 0 0 0-1 0V2H5.5A1.502 1.502 0 0 0 4 3.5V5h17V3.5A1.502 1.502 0 0 0 19.5 2zM12.5 10a4.5 4.5 0 1 0 4.5 4.5 4.505 4.505 0 0 0-4.5-4.5zm2.4 6.8a.5.5 0 0 1-.7.1l-2-1.5a.5.5 0 0 1-.2-.4v-2.5a.5.5 0 0 1 1 0v2.25l1.8 1.35a.5.5 0 0 1 .1.7z"/><path pid="1" d="M4 6v17.5A1.502 1.502 0 0 0 5.5 25h14a1.502 1.502 0 0 0 1.5-1.5V6zm8.5 14a5.5 5.5 0 1 1 5.5-5.5 5.5 5.5 0 0 1-5.5 5.5z"/>'
  }
})
